import { combineReducers } from "redux";
import companiesReducer from "./companiesReducer";
import companyReducer from "./companyReducer";
import helpFormModalReducer from "./helpFormModalReducer";
import mapReducer from "./mapReducer";
import mapSidebarReducer from "./mapSidebarReducer";
import reportsReducer from "./reportsReducer";
import sidebarReducer from "./sidebarReducer";
import subscriptionReducer from "./subscriptionReducer";
import subscriptionsReducer from "./subscriptionsReducer";
import userReducer from "./userReducer";
import vehicleReducer from "./vehicleReducer";
import vehiclesReducer from "./vehiclesReducer";
import vehicleTripsReducer from "./vehicleTripsReducer";
import { reducer as formReducer } from "redux-form";

const appReducer = combineReducers({
  companiesReducer,
  companyReducer,
  form: formReducer,
  helpFormModalReducer,
  mapReducer,
  mapSidebarReducer,
  reportsReducer,
  sidebarReducer,
  subscriptionReducer,
  subscriptionsReducer,
  userReducer,
  vehicleReducer,
  vehiclesReducer,
  vehicleTripsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOG_USER_OUT") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
